import React from 'react';
import PropTypes from 'prop-types';
import { get, map } from 'lodash-es';
import QuestionnairePresentational from './Questionnaire.presentational';
import LoanPresentational from './Loan.presentational';
import QuotationPresentational from './Quotation.presentational';
import ExtraDataPresentational from './ExtraData.presentational';
import GeneralDataPresentational from './GeneralData.presentational';
import OffersPresentational from './Offers.presentational';
import SubscriptionPresentational from './Subscription.presentational';
import DocumentsPresentational from './Documents.presentational';
import { advancementStatusEnum } from '../../../Services/SalesRoutes/enum';

const BlocksPresentational = ({
  codeStep,
  //
  isReadyQuestionnaireBlock,
  isReadyLoansBlock,
  isReadyQuotationBlock,
  isReadyExtraDataBlock,
  isReadyGeneralDataBlock,
  isReadyOffersBlock,
  isReadySubscriptionBlock,
  isReadyDocumentsBlock,
  //
  isFinishedSalesRoute,
  contracts,
  //
  blockQuestionnaire,
  blockLoans,
  blockQuotation,
  blockExtraData,
  blockGeneralData,
  blockOffers,
  blockSubscription,
  blockDocuments,
  //
  advancementStatus,
  //
  partialUpdateSalesRouteAnswers,
  partialUpdateSalesRouteLoans,
  partialUpdateSalesRouteQuotations,
  partialUpdateSalesRouteExtraData,
  partialUpdateSalesRouteGeneralData,
  partialUpdateSalesRouteContract,
  partialUpdateSalesRouteContractPrint,
  partialUpdateSalesRouteSubscription,
  partialUpdateSalesRouteDocuments,
  //
  isLoadingQuestionnaireBlock,
  isLoadingLoansBlock,
  isLoadingQuotationBlock,
  isLoadingExtraDataBlock,
  isLoadingGeneralDataBlock,
  isLoadingOffersBlock,
  isLoadingSubscriptionBlock,
  isLoadingDocumentsBlock,
  //
  cancelSalesRoute,
  putOnHoldSalesRoute,
  strings,
  //
  circularProgress,
  editField,
  willResetForm,
  onResetForm,
  willSaveForm,
  onSaveForm,
  noSaveNotValid,
  eventChangePersonType,
  i18n,
}) => {
  switch (codeStep) {
    // LES BESOINS
    case 'questionnaires': {
      if (isLoadingQuestionnaireBlock) {
        return circularProgress;
      }
      if (isReadyQuestionnaireBlock) {
        return (
          <QuestionnairePresentational
            blockQuestionnaire={blockQuestionnaire}
            isFinishedSalesRoute={isFinishedSalesRoute}
            //
            partialUpdateSalesRouteAnswers={partialUpdateSalesRouteAnswers}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            noSaveNotValid={noSaveNotValid}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }
    // LES PRÊTS
    case 'loans': {
      if (isLoadingLoansBlock) {
        return circularProgress;
      }
      if (isReadyLoansBlock) {
        return (
          <LoanPresentational
            blockLoans={blockLoans}
            isFinishedSalesRoute={isFinishedSalesRoute}
            //
            partialUpdateSalesRouteAnswers={partialUpdateSalesRouteLoans}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            noSaveNotValid={noSaveNotValid}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }
    // LES INFORMATION
    case 'quotations': {
      if (isLoadingQuotationBlock) {
        return circularProgress;
      }
      if (isReadyQuotationBlock) {
        return (
          <QuotationPresentational
            blockQuotation={blockQuotation}
            isFinishedSalesRoute={isFinishedSalesRoute}
            //
            partialUpdateSalesRouteQuotations={partialUpdateSalesRouteQuotations}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            noSaveNotValid={noSaveNotValid}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }
    // LES INFORMATIONS CONTRAT
    case 'extra_data': {
      if (isLoadingExtraDataBlock) {
        return circularProgress;
      }
      if (isReadyExtraDataBlock) {
        return (
          <ExtraDataPresentational
            blockExtraData={blockExtraData}
            isFinishedSalesRoute={isFinishedSalesRoute}
            //
            partialUpdateSalesRouteAnswers={partialUpdateSalesRouteExtraData}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            noSaveNotValid={noSaveNotValid}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }
    // LES INFORMATIONS GLOBALES
    case 'generalData': {
      if (isLoadingGeneralDataBlock) {
        return circularProgress;
      }
      if (isReadyGeneralDataBlock) {
        return (
          <GeneralDataPresentational
            blockGeneralData={blockGeneralData}
            isFinishedSalesRoute={isFinishedSalesRoute}
            //
            partialUpdateSalesRouteAnswers={partialUpdateSalesRouteGeneralData}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            noSaveNotValid={noSaveNotValid}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }
    // LES OFFRES
    case 'offers': {
      if (isLoadingOffersBlock) {
        return circularProgress;
      }
      if (isReadyOffersBlock) {
        return (
          <OffersPresentational
            blockOffers={blockOffers}
            isFinishedSalesRoute={isFinishedSalesRoute}
            contracts={contracts}
            advancementStatus={advancementStatus}
            //
            partialUpdateSalesRouteContract={partialUpdateSalesRouteContract}
            partialUpdateSalesRouteContractPrint={partialUpdateSalesRouteContractPrint}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }
    // SOUSCRIPTION
    case 'subscription': {
      if (isLoadingSubscriptionBlock) {
        return circularProgress;
      }
      if (isReadySubscriptionBlock) {
        return (
          <SubscriptionPresentational
            blockSubscription={blockSubscription}
            isFinishedSalesRoute={isFinishedSalesRoute}
            contracts={contracts}
            advancementStatus={advancementStatus}
            //
            partialUpdateSalesRouteSubscription={partialUpdateSalesRouteSubscription}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            noSaveNotValid={noSaveNotValid}
            eventChangePersonType={eventChangePersonType}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }
    // DOCUMENTS
    case 'documents': {
      if (isLoadingDocumentsBlock) {
        return circularProgress;
      }
      if (isReadyDocumentsBlock) {
        return (
          <DocumentsPresentational
            blockDocuments={blockDocuments}
            isFinishedSalesRoute={isFinishedSalesRoute}
            contracts={contracts}
            advancementStatus={advancementStatus}
            //
            partialUpdateSalesRouteDocuments={partialUpdateSalesRouteDocuments}
            cancelSalesRoute={cancelSalesRoute}
            putOnHoldSalesRoute={putOnHoldSalesRoute}
            strings={strings}
            editField={editField}
            willResetForm={get(willResetForm, codeStep, false)}
            onResetForm={onResetForm}
            willSaveForm={get(willSaveForm, codeStep, false)}
            onSaveForm={onSaveForm}
            i18n={i18n}
          />
        );
      }
      return <span />;
    }

    default:
      break;
  }
  return <span />;
};

BlocksPresentational.propTypes = {
  codeStep: PropTypes.string.isRequired,
  //
  isReadyQuestionnaireBlock: PropTypes.bool.isRequired,
  isReadyLoansBlock: PropTypes.bool.isRequired,
  isReadyQuotationBlock: PropTypes.bool.isRequired,
  isReadyExtraDataBlock: PropTypes.bool.isRequired,
  isReadyOffersBlock: PropTypes.bool.isRequired,
  isReadySubscriptionBlock: PropTypes.bool.isRequired,
  isReadyDocumentsBlock: PropTypes.bool.isRequired,
  //
  isFinishedSalesRoute: PropTypes.bool, // eslint-disable-line
  contracts: PropTypes.array, // eslint-disable-line
  blockQuestionnaire: PropTypes.object.isRequired, // eslint-disable-line
  blockLoans: PropTypes.object.isRequired, // eslint-disable-line
  blockQuotation: PropTypes.object, // eslint-disable-line
  blockExtraData: PropTypes.object, // eslint-disable-line
  blockOffers: PropTypes.array, // eslint-disable-line
  blockSubscription: PropTypes.object, // eslint-disable-line
  blockDocuments: PropTypes.object, // eslint-disable-line
  advancementStatus: PropTypes.oneOf(map(advancementStatusEnum, item => item)),
  //
  partialUpdateSalesRouteAnswers: PropTypes.func.isRequired,
  partialUpdateSalesRouteLoans: PropTypes.func.isRequired,
  partialUpdateSalesRouteQuotations: PropTypes.func.isRequired,
  partialUpdateSalesRouteExtraData: PropTypes.func.isRequired,
  partialUpdateSalesRouteContract: PropTypes.func.isRequired,
  partialUpdateSalesRouteContractPrint: PropTypes.func.isRequired,
  partialUpdateSalesRouteSubscription: PropTypes.func.isRequired,
  partialUpdateSalesRouteDocuments: PropTypes.func.isRequired,
  //
  isLoadingQuestionnaireBlock: PropTypes.bool.isRequired,
  isLoadingLoansBlock: PropTypes.bool.isRequired,
  isLoadingQuotationBlock: PropTypes.bool.isRequired,
  isLoadingExtraDataBlock: PropTypes.bool.isRequired,
  isLoadingOffersBlock: PropTypes.bool.isRequired,
  isLoadingSubscriptionBlock: PropTypes.bool.isRequired,
  isLoadingDocumentsBlock: PropTypes.bool.isRequired,
  //
  cancelSalesRoute: PropTypes.func.isRequired,
  putOnHoldSalesRoute: PropTypes.func.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  //
  circularProgress: PropTypes.element.isRequired,
  editField: PropTypes.func.isRequired,
  willResetForm: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onResetForm: PropTypes.func,
  willSaveForm: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onSaveForm: PropTypes.func,
  noSaveNotValid: PropTypes.func,
  i18n: PropTypes.object,
};

BlocksPresentational.defaultProps = {
  isFinishedSalesRoute: false,
  contracts: [],
  blockLoans: {},
  blockQuotation: {},
  blockExtraData: {},
  blockOffers: [],
  blockSubscription: {},
  blockDocuments: {},
  advancementStatus: undefined,
  strings: {},
  willResetForm: {},
  onResetForm: () => {},
  willSaveForm: {},
  onSaveForm: () => {},
  noSaveNotValid: () => {},
  i18n: {},
};

export default BlocksPresentational;
